export class FilterModel {
  fieldName: string;
  fieldType: string;
  values: string[];
}
